import React, { useState } from "react";
import BookModal from "../book/BookModal";
import { Link, useNavigate } from "react-router-dom";
import { teamData } from "../../data/team";

import "./Team.css";

const Team = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate()

  // function to show the modal
  const showModal = () => {
    setShow(true);
  };

  // function to close the modal
  const closeModal = () => {
    setShow(false);
  };
  return (
    <div className="team" id="doctors">
      <h1>Choose Your Doctor</h1>
      <div className="team-members">
        {teamData.map((data, index) => {
          return (
            <div className="member" key={index}>
              <img src={data.imageUrl} alt={data.name} />
              <h3>{data.name}</h3>
              <p>{data.description}</p>
              <span></span>
              <h6>
                <i>{data.icon}</i>
                <a href={data.phone}>{data.phone}</a>
              </h6>
              <BookModal show={show} handleClose={closeModal}></BookModal>
              <button className="book-btn" onClick={showModal}>
                Book Now!
              </button>
            </div>
          );
        })}
      </div>
      <Link className="more-btn" to='/doctors'>
        <span>+</span>See More!
      </Link>
    </div>
  );
};

export default Team;
